import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-credit-sanction-form',
  templateUrl: './leave-credit-sanction-form.component.html',
  styleUrls: ['./leave-credit-sanction-form.component.css']
})
export class LeaveCreditSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-form/leave-credit-sanction-form.component.ts